import { render, staticRenderFns } from "./ServiceProviderDocuments.vue?vue&type=template&id=6bb5e69a&"
import script from "./ServiceProviderDocuments.vue?vue&type=script&lang=js&"
export * from "./ServiceProviderDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ServiceProviderDocuments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports